import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
import { CTAButton } from './ui/CTAButton';
const discoveries = ['Cómo reconocer la depresión', 'Cómo construir hábitos que estabilicen tu mente', 'Cómo usar ejercicio, nutrición y meditación para mejorar tu estado emocional', 'Cómo rodearte de relaciones positivas'];
export function SalesLetterSection() {
  return <section className="py-28 md:py-32 px-4 relative overflow-hidden" data-id="element-219">
      {/* Background Image */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-220">
        <img src="https://cdn.magicpatterns.com/uploads/imvn1P5XeaM4CxtYvFkxAZ/ChatGPT_Image_14_mar_2026,_12_14_19_a.m..png" alt="" className="w-full h-full object-cover" data-id="element-221" />
        <div className="absolute inset-0 bg-[#F7F3E9]/75" data-id="element-222"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-223">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white rounded-3xl border border-[#E8E1D5] shadow-[0_10px_30px_rgba(47,58,61,0.08)] p-10 md:p-14" data-id="element-224">
          {/* Opening — intimate, personal tone */}
          <div className="space-y-6 text-center mb-12" data-id="element-225">
            <p className="text-xl text-[#F4A261] italic font-serif" data-id="element-226">
              Si estás leyendo esto…
            </p>
            <p className="text-2xl text-[#2F3A3D] leading-relaxed font-medium" data-id="element-227">
              Probablemente estés pasando por un momento difícil.
            </p>
            <p className="text-lg text-[#5F6368] leading-relaxed" data-id="element-228">
              Tal vez te sientes cansado, desmotivado o atrapado en pensamientos
              negativos.
            </p>
            <p className="text-lg text-[#5F6368] leading-relaxed" data-id="element-229">
              La depresión puede hacer que todo parezca oscuro.
            </p>
          </div>

          {/* Turning point */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-center my-12 py-8 border-y border-[#E8E1D5]" data-id="element-230">
            <p className="text-sm uppercase tracking-widest text-[#F4A261] mb-4 font-bold" data-id="element-231">
              Pero quiero que sepas algo importante:
            </p>
            <p className="text-4xl md:text-5xl font-bold font-serif text-[#2F3A3D]" data-id="element-232">
              Hay salida.
            </p>
          </motion.div>

          {/* Bridge */}
          <div className="space-y-5 text-center mb-12" data-id="element-233">
            <p className="text-lg text-[#5F6368] leading-relaxed" data-id="element-234">
              Y muchas personas han logrado recuperar su bienestar emocional
              aprendiendo las herramientas correctas.
            </p>
            <p className="text-lg text-[#5F6368] leading-relaxed" data-id="element-235">
              Por eso creé esta guía.
            </p>
          </div>

          {/* Book title callout */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-center mb-12 p-8 bg-[#F7F3E9] rounded-2xl border border-[#E8E1D5]" data-id="element-236">
            <h3 className="text-3xl md:text-4xl font-bold font-serif text-[#2F3A3D] mb-4" data-id="element-237">
              Camino a la Luz
            </h3>
            <p className="text-lg text-[#5F6368] leading-relaxed" data-id="element-238">
              Un ebook práctico que reúne estrategias reales para ayudarte a
              mejorar tu bienestar emocional.
            </p>
          </motion.div>

          {/* What you'll discover */}
          <div className="mb-12" data-id="element-239">
            <p className="text-center text-xl text-[#2F3A3D] font-serif font-bold mb-8" data-id="element-240">
              Dentro descubrirás:
            </p>
            <div className="space-y-4" data-id="element-241">
              {discoveries.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -15
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.1 * index
            }} className="flex items-start gap-4 p-4 rounded-2xl bg-white border border-[#E8E1D5] hover:shadow-md transition-shadow" data-id="element-242">
                  <div className="flex-shrink-0 mt-0.5" data-id="element-243">
                    <div className="w-8 h-8 rounded-full bg-[#7FB77E]/15 flex items-center justify-center" data-id="element-244">
                      <CheckIcon className="w-5 h-5 text-[#7FB77E]" data-id="element-245" />
                    </div>
                  </div>
                  <p className="text-[#5F6368] leading-relaxed text-lg" data-id="element-246">
                    {item}
                  </p>
                </motion.div>)}
            </div>
          </div>

          {/* Closing — emotional push */}
          <div className="space-y-5 text-center mb-12" data-id="element-247">
            <p className="text-lg text-[#5F6368]" data-id="element-248">
              <strong className="text-[#2F3A3D]" data-id="element-249">No es magia.</strong> Es un
              proceso.
            </p>
            <p className="text-xl text-[#F4A261] italic font-serif" data-id="element-250">
              Un paso a la vez.
            </p>
            <p className="text-lg text-[#5F6368] leading-relaxed" data-id="element-251">
              Este ebook puede ser el inicio de tu transformación.
            </p>
          </div>

          {/* Final emotional hook */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center pt-10 border-t border-[#E8E1D5]" data-id="element-252">
            <p className="text-xl text-[#5F6368] leading-relaxed mb-3" data-id="element-253">
              Si hoy decides dar ese primer paso…
            </p>
            <p className="text-3xl font-serif font-bold text-[#2F3A3D] mb-10" data-id="element-254">
              Tu futuro puede verse completamente diferente.
            </p>
            <CTAButton href="#precio" onClick={trackAddToCart} className="w-full sm:w-auto" data-id="element-255">
              Haz clic ahora y comienza tu camino hacia la luz
            </CTAButton>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}